import React, { useEffect, useCallback, useState} from 'react';
import {useSequencer} from 'components/v2/useSequencer.js';
import ExportHelper from './ExportHelper.js';
import {connect} from 'react-redux';

const ExportFull = (props) => { 
    let [ethereumCache, sequencerEngine, ethereumSearcher] = useSequencer({
        ...props,
        skipSampleRate: true
    });
    
    return (
        <div>
          <ExportHelper sequencerEngine={sequencerEngine}/>
        </div>
    );
}

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExportFull);
